export default {
  presets: {
    light: {
      backgroundPrimary: '#F7F9F9',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#39cc39',
      info: '#3f5fbf',
      danger: '#D32F2F',
      warning: '#ffbe02',
      gray: '#dadadaff',
      primary: '#0b193d',
      facebook: '#0866ff',
      gmail: '#ff4343',
      secondary: '#4ba3c3',
      white: '#ffffff',
    },
    dark: {
      backgroundCardPrimary: '#1b3c59',
      backgroundCardSecondary: '#D32F2F',
      white: '#fff',
    },
  },
}
